import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
// import Link from "@mui/material/Link";

const cardStyle = {
  bgcolor: "#fff",
  color: "#4f4f4f",
};

const data = [
  {
    title: "BATNF FTF PROJECT (2020 - 2021)",
    subtitle:
      "The British America Tobacco Nigeria Foundation (BATNF) Fingerlings to Fork (FTF) project implemented by AHAN was hosted in April, 2021 in Yenagoa, Bayelsa State with 300 women and youths as project beneficiaries. The beneficiaries were trained on the 21st century approach towards promoting Good Aquaculture Practices and the best cohort were supported with a Modern Smoking Kiln. ",
    link: "/our-services/technical-department",
  },
  {
    title: "AFOS GERMAN FOUNDATION (2020)",
    subtitle:
      "The AFOS German-Nigeria Foundation COVID-19 project was centred on supporting their long-term farmers with capacity building sessions delivered by AHAN on Fish Processing, Packaging, Preservation and Value-Addition and this was carried out in four different locations across Nigeria. The best of the trainees were also selected to enjoy capacity building sessions in Aquaponics with AHAN and this was well carried out; the trainees were then supported with Modern Smoking Kilns and Aquaponics Systems setup.",
    link: "/our-services/farm-services",
  },

  {
    title: "BAV FEED AFRICA (2019 - 2020)",
    subtitle:
      "The Bayelsa State Government contracted Aquatic Hub Afrique Network, the training partner of Aquaseas Company Limited to train and equip 1000 Bayelsa Women and Youths on Aquaculture Enterprise Development; this we did across four cohorts. The program commenced in 2019 and ended in 2020.",
    link: "/our-services/technical-department",
  },
  {
    title: "WORLD BANK APPEALS PROJECT (2019 - 2020)",
    subtitle:
      "Aquatic Hub Afrique Network was contracted to equip 502 beneficiaries with knowledge about Aquaculture Enterprise Development while also ensuring they tour other value-chains of Aquaculture. Beneficiaries were trained and later supported with Start-up grants.",
    link: "/our-services/training-institute",
  },
  {
    title: "FADAMA GUYS (2018)",
    subtitle:
      " In 2018, Aquatic Hub Afrique Network was contracted to build the capacity of Fifty-four (54) beneficiaries of the Third National Fadama Development Project (Fadama III) tagged FADAMA Graduate and Unemployed Youths Scheme (GUYS).",
    link: "/our-services/farm-services",
  },
  {
    title: "WAAPP (2017)",
    subtitle:
      " The West African Agriculture Productivity Program (WAAPP) was a springboard for our organizations to attain milestone achievements in the production of quality fingerlings for fish farmers in Nigeria. The program also helped us devise a strategy to own our value chain in commercial aquaculture. while also continuing to excel in fish production and expanding into processing and packaging of different fish products.",
    link: "/our-services/training-institute",
  },
];

const ProjectDetails = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "10% 0%" }}>
      <Typography
        variant={"body1"}
        fontWeight={900}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"1%"}
      >
        INDUSTRY EXPERIENCE
      </Typography>
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#00AEEF"}
        paddingBottom={"1%"}
      >
        <Typography
          component={"span"}
          variant={"h3"}
          color="#3E4095"
          fontWeight={900}
        >
          Our {""}
        </Typography>
        Projects
      </Typography>
      <Typography
        variant={"body1"}
        fontWeight={400}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"2%"}
      >
        Our industry experience, spanning over 20 years has enabled us commence
        and conclude several programs and projects of different magnitudes. Some
        of these programs and projects can be viewed below:
      </Typography>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const { title, subtitle } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={index}
                marginTop={{ xs: "15%", sm: "3%" }}
              >
                <Box
                  component={Card}
                  height={"100%"}
                  padding={"5% 6%"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  margin={{ xs: "4% 0%", sm: "2% 0%" }}
                  data-aos={"fade-down"}
                  sx={{ ...cardStyle }}
                >
                  <Typography
                    variant={"h4"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#3E4095"}
                  >
                    {title}
                  </Typography>
                  <Typography variant={"body1"} paddingTop={"6%"}>
                    {subtitle}
                  </Typography>
                  <Grid item xs={12} marginTop={{ xs: "0%", sm: "4%" }}>
                    <Divider color={"#fff"} />
                  </Grid>
                  {/* <Box marginLeft={{ xs: " 0%", sm: "0%" }} paddingTop={"2%"}>
                    <Link
                      underline="none"
                      component="a"
                      href={link}
                      textAlign={"left"}
                      color="#00AEFF"
                      fontWeight={700}
                      sx={{
                        "&:hover": {
                          color: "#3E4095",
                        },
                      }}
                    >
                      Read More &#10141;
                    </Link>
                  </Box> */}
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ProjectDetails;
